import cn from "classnames";
import { ChevronDown } from "@rshbintech.dboul/icons";
import { ARROW_DIRECTIONS } from "./constants";
import { NavigationIconProps } from "./types";
import styles from "./styles.module.scss";

export const NavigationIcon = ({
  className,
  direction,
  onClick,
  disabled = false,
  dataTestId,
}: NavigationIconProps) => (
  <button
    type="button"
    className={cn(styles.icon, className)}
    onClick={onClick}
    onKeyDown={onClick}
    disabled={disabled}
    data-test-id={dataTestId}
  >
    <ChevronDown
      className={cn({
        [styles["left-direction"]]: direction === ARROW_DIRECTIONS.LEFT,
        [styles["right-direction"]]: direction === ARROW_DIRECTIONS.RIGHT,
      })}
    />
  </button>
);
